import React, { Component } from 'react'
import { observer } from 'mobx-react'
import RolesStore from '../../stores/RolesStore'
import { Button, Grid, Header, Icon, Menu, Pagination, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import LoadingWrapper from '../../components/LoadingWrapper'

@observer
class RolesScreen extends Component {
  constructor (props) {
    super(props)
    this.rolesStore = new RolesStore()
    window.document.title = 'Liste des rôles'
  }

  componentDidMount () {
    this.rolesStore.loadAll()
  }

  changePage = (page) => {
    this.rolesStore.changePage(page.activePage)
    this.rolesStore.loadAll()
  }

  render () {
    const { paging, roles, isLoading } = this.rolesStore
    return (
      <>
        <Header as='h2'>Liste des rôles</Header>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Menu secondary>
          <Menu.Item>
            <Button primary icon as={Link} to='/roles/create'><Icon name='plus' />Ajouter un nouveau rôle</Button>
          </Menu.Item>
        </Menu>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              {paging.Roles && <Pagination
                onPageChange={(e, data) => this.changePage(data)}
                totalPages={paging.Roles.pageCount}
                activePage={paging.Roles.page}
                               />}
              {!!roles.length &&
                <Table celled>
                  <Table.Header key='header'>
                    <Table.Row>
                      <Table.HeaderCell>Nom</Table.HeaderCell>
                      <Table.HeaderCell>Modifiable</Table.HeaderCell>
                      <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body key='body'>
                    {roles.map(role => {
                      return (
                        <Table.Row key={`role_${role.id}`}>
                          <Table.Cell>
                            {role.editable ? (<Link to={`/roles/edit/${role.id}`}>{role.name}</Link>) : (<>Admin</>)}
                          </Table.Cell>
                          <Table.Cell>
                            {role.editable ? 'Oui' : 'Non'}
                          </Table.Cell>
                          <Table.Cell>
                            {role.editable && <Link to={`/roles/edit/${role.id}`}><Icon link name='pencil' /></Link>}
                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                </Table>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default RolesScreen
